<template>
  <div class="site-page site-page--hub nav-content-inset">
    <div class="site-page__inner">
      <AccountWalletNav />
      <h1 class="site-page__title">申请臻享合伙人</h1>
      <p class="hint">须先完成实名认证。审核通过后可设置臻享礼券并享有客户终身分润。</p>

      <el-alert
        v-if="!loadingVerify && !isVerified"
        type="warning"
        :closable="false"
        show-icon
        title="请先完成实名认证"
        class="verify-alert"
      >
        <template #default>
          <p>合伙人申请需要上传身份证并通过审核。</p>
          <el-button type="primary" size="small" @click="$router.push('/real-name-verification')">
            去实名认证
          </el-button>
        </template>
      </el-alert>

      <el-alert v-if="status" :type="statusType" :closable="false" class="status-alert">
        当前状态：<strong>{{ statusLabel }}</strong>
        <span v-if="status.adminReply"> — {{ status.adminReply }}</span>
      </el-alert>

      <el-card v-if="canApply && isVerified" shadow="never">
        <el-form label-width="100px" @submit.prevent="submit">
          <el-form-item label="真实姓名" required>
            <el-input v-model="form.realName" maxlength="32" placeholder="与实名认证一致" />
          </el-form-item>
          <el-form-item label="身份证号" required>
            <el-input v-model="form.idCardNo" maxlength="18" />
          </el-form-item>
          <el-form-item label="联系电话" required>
            <el-input v-model="form.phone" maxlength="20" />
          </el-form-item>
          <el-form-item label="申请说明">
            <el-input v-model="form.intro" type="textarea" :rows="3" maxlength="500" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="submitting" @click="submit">提交申请</el-button>
            <el-button @click="$router.push('/referral/earnings')">查看推荐收益</el-button>
            <el-button @click="$router.push('/my')">返回我的</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
import AccountWalletNav from '@/components/AccountWalletNav.vue'
import {
  fetchPartnerApplyStatus,
  submitPartnerApply,
  fetchUserVerificationBrief,
  fetchIdCardProfile,
  PARTNER_STATUS_LABELS
} from '@/utils/userHub'

export default {
  name: 'PartnerApplyView',
  components: { AccountWalletNav },
  data() {
    return {
      status: null,
      submitting: false,
      loadingVerify: true,
      isVerified: false,
      form: { realName: '', idCardNo: '', phone: '', intro: '' }
    }
  },
  computed: {
    statusLabel() {
      return PARTNER_STATUS_LABELS[this.status?.status] || this.status?.status || '—'
    },
    statusType() {
      const m = { pending: 'warning', approved: 'success', rejected: 'error' }
      return m[this.status?.status] || 'info'
    },
    canApply() {
      return !this.status || this.status.status === 'rejected'
    }
  },
  created() {
    this.loadVerify()
    this.loadStatus()
  },
  methods: {
    async loadVerify() {
      this.loadingVerify = true
      try {
        const brief = await fetchUserVerificationBrief()
        this.isVerified = brief.isVerified
        const idcard = await fetchIdCardProfile()
        if (idcard?.realName && !this.form.realName) {
          this.form.realName = idcard.realName
        }
        if (idcard?.idCardNumber && !this.form.idCardNo) {
          this.form.idCardNo = idcard.idCardNumber
        }
      } catch (e) {
        console.warn('load verify brief failed', e)
      } finally {
        this.loadingVerify = false
      }
    },
    async loadStatus() {
      try {
        this.status = await fetchPartnerApplyStatus()
      } catch (e) {
        this.$message.error(e.message || '加载失败')
      }
    },
    async submit() {
      if (!this.isVerified) {
        this.$message.warning('请先完成实名认证')
        this.$router.push('/real-name-verification')
        return
      }
      this.submitting = true
      try {
        this.status = await submitPartnerApply(this.form)
        this.$message.success('申请已提交，请等待审核')
      } catch (e) {
        this.$message.error(e.message || '提交失败')
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
.hint { color: #666; margin-bottom: 16px; }
.status-alert { margin-bottom: 16px; }
.verify-alert { margin-bottom: 16px; }
.verify-alert p { margin: 0 0 10px; }
</style>
